import i18n from 'i18next';
import translations from './locales/translation';

const resources = translations;

// this as another instance of i18n
// mainly for address, where '.' will got interpret as separate character, i.e. Virgin Islands (U.S.)
// this instance will use "::" to escape keys

const newInstance = i18n.createInstance();

newInstance.init({
  resources,
  fallbackLng: 'zhTW',
  debug: true,

  defaultNS:'translation',

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  keySeparator: ':',
  react: {
    wait: true,
  }
});

export default newInstance;
